import { ICompanyTag } from "@interfaces/tag.interface";
import { CompanyAvatar, CompanyAvatarSizes } from "@ui/Avatars/CompanyAvatar";
import { TagLabel } from "@ui/Content";

type Props = {
  item: ICompanyTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionCompany = ({ item, ...rest }: Props) => {
  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <CompanyAvatar
        size={CompanyAvatarSizes.BIG}
        classNames="!rounded-[5px] w-5 h-5 border border-gray-200 bg-background-clear flex-shrink-0"
        logoUrl={item.logo || item.logo_url}
      />
      <TagLabel>{item.title}</TagLabel>
    </div>
  );
};
